import { Inject, Injectable } from '@angular/core';
import { downgradeToAJSService, CommonsSessionStorageService } from 'ib-web-commons/utils';
import { GiftCardsAppConstant } from '@src/ib-gift-cards-constants';
import { GiftCardsSummaryService } from './ib-gift-cards-summary-service';
import { initGiftCardServiceModel } from '@core/models/summary-service.model';
import { SummaryProps } from 'commercial-management--ancillaries--web-components-design--library';


export type PaymentContextResponse = {data:{contextId:string}};
@Injectable({
    providedIn: 'root'
})
export class GiftCardsPaymentService {

    summaryResponse:SummaryProps;

    constructor (
        @Inject('NewMainHeaderFacade') private newMainHeaderFacade: any,
        @Inject('CommonsGenericProxy') private CommonsGenericProxy,
        private commonsSessionStorageService: CommonsSessionStorageService,
        private giftCardsSummaryService: GiftCardsSummaryService
    ) {
    }

    async init (): Promise<initGiftCardServiceModel> {
        this.newMainHeaderFacade.showLogin();
        this.updateSteps(this.commonsSessionStorageService.get('actualStepFlow'));
        const flowId: string = this.commonsSessionStorageService.get('flowId');
        const headerConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'accept': '*/*'
            }
        };

        const postData ={
            redirection:{
                success: {
                    url: 'string',
                    data: 'string',
                    method: 'string'
                },
                failure: {
                    url: 'string',
                    data: 'string',
                    method: 'string'}
            }
        };

        let paymentContextResponse:string = this.commonsSessionStorageService.get(GiftCardsAppConstant.SESSION_STORAGE.PAYMENT_CONTEXT_RESPONSE);
        if(!paymentContextResponse){
            const response:PaymentContextResponse=await this.CommonsGenericProxy.postGeneric(GiftCardsAppConstant.DEFAULT_ENDPOINTS.PAYMENT_CONTEXT.replace('{flowId}', flowId), postData, headerConfig);
            paymentContextResponse = response.data.contextId;
        }

        this.summaryResponse = this.commonsSessionStorageService.get(GiftCardsAppConstant.SESSION_STORAGE.SUMMARY) as SummaryProps;
        if(!this.summaryResponse) {
            this.summaryResponse = await this.giftCardsSummaryService.getSummary();
        }

        this.commonsSessionStorageService.set(GiftCardsAppConstant.SESSION_STORAGE.PAYMENT_CONTEXT_RESPONSE, paymentContextResponse);
        this.commonsSessionStorageService.set(GiftCardsAppConstant.SESSION_STORAGE.SUMMARY, this.summaryResponse);
        return{
            paymentContext: paymentContextResponse,
            summaryPros: this.summaryResponse
        };
    }

    getSummaryResponse (): SummaryProps {
        return this.summaryResponse;
    }

    updateSteps (position) {
        this.newMainHeaderFacade.updateStepsModel(position);
    }
}

downgradeToAJSService('GiftCardsPaymentService', GiftCardsPaymentService, 'ib-gift-cards-payments-module');
